module.exports = __webpack_public_path__ + "img/Add.806e3201.svg";